export const getPlaceholderMask = (value: string, mask: string) => mask.slice(value.length);

export const isEditableIndex = (patternIndex: number, permanents: number[]) =>
    !permanents.includes(patternIndex);

/**
 * Функция используется для проверки корректности отображения значения телефона в инпуте с использование маски.
 * Функция,  оставить только цифры, и символы использующиеся в маске "+7 abc(123)" -> "+7 (123)",
 * обрежет двойные пробелы '+7  (999)  999- 99-99'  -> '+7 (999) 999-99-99'
 * @param value строка с номером телефона
 */
export const getCorrectDisplayedPhone = (value: string) =>
    value
        .trim()
        .replace(/[^\d\s()+-]+/g, '')
        .replace(/\s+/g, ' ');
